import React, { useEffect } from "react";
import "../../my-dashboard.scss";
import useUpcomingEvents, { Event } from "./useUpcomingEvents";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { useNavigate } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";

const UpcomingEvents = ({ handleSelectEvent }) => {
  const navigate = useNavigate();
  const { eventsData, isLoading, formatDueDate } = useUpcomingEvents();

  return (
    <div className="upcoming-events-container">
      <div className="heading">Upcoming Events</div>
      {isLoading ? (
        <div className="flex flex-column gap-0">
          {Array.from({ length: 4 })?.map((_, index) => (
            <div key={index} className="field p-0">
              <Skeleton width="100%" height="175px" />
            </div>
          ))}
        </div>
      ) : (
        <div className="event-cards">
          {eventsData?.map((event: Event) => (
            <Card
              className="cursor-pointer"
              key={event.id}
              style={{
                borderInlineStartColor: event.primary_color,
                backgroundColor: event.secondary_color,
              }}
              onClick={() => {
                handleSelectEvent(event);
              }}
            >
              <p className="event-service-name">{event.serviceName}</p>
              <p className="event-name-status">{`${event.name} (${event.statusName})`}</p>
              <p className="event-process-name">{event.processName}</p>
              <p className="event-entity-name">
                <ReactCountryFlag
                  countryCode={event.entityCountry || ""}
                  svg
                  className=""
                />
                {" " + event.entityName}
              </p>
              <p className="event-due-date">
                {`Deadline: ${formatDueDate(event.due_date)}`}
              </p>
            </Card>
          ))}
          <Button
            label="View More - Calendar"
            className="view-calendar-btn"
            onClick={() => navigate("/calendar")}
          />
        </div>
      )}
    </div>
  );
};

export default UpcomingEvents;
